function MainSlider( $ ) {

  // setup properties
  const slider = $('.main-slider__slider');
  const $slides = $('.main-slider__slider-slide');

  // slick slider settings
  const settings = {
    speed: 500,
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          arrows: true,
          centerMode: false,
          variableWidth: false
        }
      }
    ]
  };
  
  // state holders for adjustSlideWidth function
  let slideTabletAdjusted = false;
  let desktopTabletAdjusted = false;
  
  /*
   * Function that set slide width equal to slides image width.
   * Will be used only on Edge browser
   */
  function adjustSlideWidth() {
    let $windowWidth = $(window).width();
    if( $windowWidth >= 768 && $windowWidth < 1200 && !slideTabletAdjusted) {
      $slides.each(function() {
        let imageWidth = this.firstElementChild.firstElementChild.width;
        $(this).css('width', imageWidth);
      });
      slideTabletAdjusted = true;
      desktopTabletAdjusted = false;
    } else if($windowWidth >= 1200 && !desktopTabletAdjusted) {
      $slides.each(function() {
        let imageWidth = this.firstElementChild.firstElementChild.width;
        $(this).css('width', imageWidth);
      });
      desktopTabletAdjusted = true;
      slideTabletAdjusted = false;
    }
  }

  /**
	* initialization method, set up slick slider
	*/
  function init() {
    // if on Edge call adjustSlideWidth function
    if(window.navigator.userAgent.indexOf("Edge") > -1) {
      adjustSlideWidth();
    }
    slider.slick(settings);
  }

  $( window ).on( 'resize', function() {
    // if on Edge call adjustSlideWidth function
    if(window.navigator.userAgent.indexOf("Edge") > -1) {
      adjustSlideWidth();
    }
  });

  return {
    init
  }
}

export default MainSlider;


